<script>
import { XIcon } from 'vue-feather-icons'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  extends: BaseModal,
  components: { XIcon },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close(false)")
  .modal-body
    h1.page__header {{ $t('pickup.pickupInfoModal.header') }}
    h3.page__description.mb-5 {{ $t('pickup.pickupInfoModal.desc1') }}
    h3.page__description.mb-5 {{ $t('pickup.pickupInfoModal.desc2') }}
</template>

<style lang="scss" scoped></style>
